<template lang="html">
    <div id="auth">
        <form class="form" @submit.prevent="sendForm">
            <div class="form-group">
                <label>Name</label>
                <input data-cy="name" type="text" v-model="form.name" />
                <has-error data-cy="name_error" :form="form" field="name"></has-error>
            </div>

            <div class="form-group">
                <label>Email</label>
                <input data-cy="email" type="email" v-model="form.email" />
                <has-error data-cy="email_error" :form="form" field="email"></has-error>
            </div>

            <div class="form-group">
                <label>Phone Country code</label>
                <input type="text" maxlength="2" v-model="form.phone_cc" />
            </div>

            <div class="form-group">
                <label>Phone number</label>
                <input data-cy="phone" type="text" v-model="form.phone" />
                <has-error data-cy="phone_error" :form="form" field="phone"></has-error>
            </div>

            <div class="form-group">
                <label>Password</label>
                <input data-cy="password" type="password" v-model="form.password" />
                <has-error data-cy="password_error" :form="form" field="password"></has-error>
            </div>

            <div class="form-group">
                <button :disabled="form.busy" data-cy="submit" type="submit" name="button">
                    {{ form.busy ? "Please wait" : "Register" }}
                </button>
            </div>

            <router-link to="login">Login</router-link>
        </form>
    </div>
</template>

<script>
import Cookie from "js-cookie";
import { Form, HasError } from "vform";
export default {
    name: "login",
    components: { HasError },
    data() {
        return {
            form: new Form({
                name: "",
                email: "",
                password: "",
                phone_cc: 44,
                phone: "07715274653",
            }),
        };
    },
    methods: {
        sendForm() {
            this.form
                .post("/register")
                .then((response) => {
                    Cookie.set(process.env.VUE_APP_AUTH_COOKIE_NAME, response.data.api_token);
                    this.$store.state.user = response.data;
                    this.$router.push({ name: "Home" });
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        alert("Invalid credentials");
                    }
                });
        },
    },
};
</script>

<style lang="less">
.form {
    .form-group {
        label {
            display: block;
        }
        input[type="text"],
        input[type="email"],
        input[type="password"] {
            width: 100%;
        }
    }
}
</style>
